module.exports = __webpack_public_path__ + "static/ebook_cover01-f60b93af0d4f20bbe5d73d1d92964ddb.jpg";